import api from '../index'

export default {
  // 登录
  login: (data: {
    account: string
    password: string
  }) => api.post('auth/employeLlogin', data),

  // 获取权限
  permission: () => api.post('auth/getPermission'),
  // 获取个人信息
  profile: () => api.get('auth/profile'),

  // 查询当前账号的新手引导进度。三个版本统一走这一套接口和处理逻辑，不按版本区分。
  // x-type / x-domain / Authorization 等请求头继续由 src/api/index.ts 公共拦截器统一处理。
  getOnboardingProgress: () => api.get('v1/me/onboarding/enterprise-onboarding'),

  // 保存当前账号的新手引导进度。三个版本统一使用该 PATCH 接口。
  // GET 返回 cursor.taskId / cursor.stepId，PATCH 按后端契约使用
  // cursor.currentTaskId / cursor.currentStepId，字段转换统一放在 onboarding Store 中。
  patchOnboardingProgress: (data: any) => api.patch('v1/me/onboarding/enterprise-onboarding', data),

  // 清空当前账号的路线、任务和步骤进度。
  resetOnboardingProgress: (data: any) => api.post('v1/me/onboarding/enterprise-onboarding/reset', data),

  // 修改资料
  profileEdit: (data: any) => api.post('auth/profileEdit', data),

  // 获取偏好设置
  preferences: () => api.get('user/preferences', {
    baseURL: '/mock/',
  }),

  // 修改偏好设置
  preferencesEdit: (preferences: string) => api.post('user/preferences/edit', {
    preferences,
  }, {
    baseURL: '/mock/',
  }),

  // 获取标签栏固定标签页数据
  tabbar: () => api.get('user/tabbar', {
    baseURL: '/mock/',
  }),

  // 修改标签栏固定标签页数据
  tabbarEdit: (tabbar: string) => api.post('user/tabbar/edit', {
    tabbar,
  }, {
    baseURL: '/mock/',
  }),

  // 获取收藏夹
  favorites: () => api.get('user/favorites', {
    baseURL: '/mock/',
  }),

  // 修改收藏夹
  favoritesEdit: (favorites: string) => api.post('user/favorites/edit', {
    favorites,
  }, {
    baseURL: '/mock/',
  }),

  getTenantStudio: () => api.get('auth/tenantStudio'),
}
